import {
  Checkbox as ChakraCheckbox,
  type StyleProps,
  type ThemingProps,
} from '@chakra-ui/react';
import React from 'react';

type CheckboxProps = {
  id?: string;
  name?: string;
  value?: string | number;
  isChecked?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  isRequired?: boolean;
  isDisabled?: boolean;
  isInvalid?: boolean;
  style?: React.CSSProperties;
  sx?: object;
  ref?: React.Ref<any>;
  children?: React.ReactNode;
  defaultChecked?: boolean;
  checked?: boolean;
  tabIndex?: number;
  isReadOnly?: boolean;
} & ThemingProps<'Checkbox'> &
  StyleProps;

const Checkbox = React.forwardRef<any, CheckboxProps>(
  ({ children, ...props }, ref) => {
    return (
      <ChakraCheckbox ref={ref} {...props}>
        {children}
      </ChakraCheckbox>
    );
  },
);

Checkbox.displayName = 'Checkbox';

export default Checkbox;
